import { combineReducers } from "redux";
import stations from "./Stations";
import session from "./Session";
import firebase from "./Firebase";
import tokens from "./Tokens"
import users from "./Users"
import loads from "./Loads"

export default combineReducers({
    stations,
    session,
    firebase,
    tokens,
    users,
    loads
});